import { useState, useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import constants from "./../../../constants";
import staffRepository from "repositories/staff-repository";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

export const useStaffActions = (globalStaffDetail) => {
  const location = useLocation();
  const history = useHistory();
  const [substituteSelectionEvent, setSubstituteSelectionEvent] =
    useState(null);
  const [
    isSubstituteSelectorActionExecuting,
    setIsSubstituteSelectorActionExecuting,
  ] = useState(false);
  const [substituteSelectorErrorMessage, setSubstituteSelectorErrorMessage] =
    useState("");
  const [staffActionEvent, setStaffActionEvent] = useState(null);
  const dispatch = useDispatch();
  const goBackToStaffList = useCallback(() => {
    dispatch({ type: "ResetStaffReducer" });
    // history.push({
    //   pathname: `/Staff/${encodeId(locationState.OfficeId)}`,
    //   state: {
    //     ...locationState,
    //     officeName: locationState.officeName || officeDetail?.name,
    //   },
    // });
    history.goBack();
  }, [history, dispatch]);
  useEffect(() => {
    if (location.search) {
      const searchParams = new URLSearchParams(location.search);
      const value = searchParams.get("action");
      const isMultiple = searchParams.get("isMultiple");
      if (value) {
        if (isMultiple) {
          setSubstituteSelectionEvent(
            value === "1"
              ? constants.staffActionEvents.multipleDeactivationConfirm
              : value === "2"
                ? constants.staffActionEvents.multipleRemoveConfirm
                : value === "3"
                  ? constants.staffActionEvents.multipleActivationConfirm
                  : constants.staffActionEvents.multipleCancelConfirm,
          );
        } else {
          setSubstituteSelectionEvent(
            value === "1"
              ? constants.staffActionEvents.deactivation
              : value === "2"
                ? constants.staffActionEvents.removal
                : constants.staffActionEvents.cancelInvitation,
          );
        }
      }
    }
  }, [location.search]);
  const exitSubstituteSelectionJourney = useCallback(() => {
    if (location.search) {
      history.goBack();
    } else {
      setSubstituteSelectionEvent(null);
      setSubstituteSelectorErrorMessage("");
      setIsSubstituteSelectorActionExecuting(false);
    }
  }, [location.search, history]);

  const substituteSelectorAction = useCallback(
    async (userId, officeId, transferWorkItemsTo) => {
      setIsSubstituteSelectorActionExecuting(true);
      setSubstituteSelectorErrorMessage("");
      let res;
      if (substituteSelectionEvent === constants.staffActionEvents.removal) {
        res = await staffRepository.removeStaff(
          userId,
          officeId,
          transferWorkItemsTo,
        );
      } else {
        res = await staffRepository.deactivateStaff(
          userId,
          officeId,
          transferWorkItemsTo,
        );
      }

      if (res.statusCode === 200) {
        if (!location.search) {
          exitSubstituteSelectionJourney();
        }
        goBackToStaffList();
      } else {
        setSubstituteSelectorErrorMessage(res.message);
        setIsSubstituteSelectorActionExecuting(false);
      }
    },
    [
      substituteSelectionEvent,
      exitSubstituteSelectionJourney,
      goBackToStaffList,
    ],
  );

  const clearSubstituteSelectorErrorMessage = useCallback(() => {
    setSubstituteSelectorErrorMessage("");
  }, []);

  const onRemoveStaffDropdownItemClick = useCallback(() => {
    const isAdmin = globalStaffDetail?.isAdmin;
    if (isAdmin) {
      setSubstituteSelectionEvent(constants.staffActionEvents.removal);
    } else {
      setStaffActionEvent(constants.staffActionEvents.removal);
    }
  }, [globalStaffDetail?.isAdmin]);

  const onDeactivateStaffDropdownItemClick = useCallback(() => {
    const isAdmin = globalStaffDetail?.isAdmin;
    if (isAdmin) {
      setSubstituteSelectionEvent(constants.staffActionEvents.deactivation);
    } else {
      setStaffActionEvent(constants.staffActionEvents.deactivation);
    }
  }, [globalStaffDetail?.isAdmin]);

  const onActivateStaffDropdownItemClick = useCallback(() => {
    setStaffActionEvent(constants.staffActionEvents.activation);
  }, []);

  return {
    substituteSelectionEvent,
    isSubstituteSelectorActionExecuting,
    substituteSelectorErrorMessage,
    staffActionEvent,
    setSubstituteSelectionEvent,
    setStaffActionEvent,
    goBackToStaffList,
    exitSubstituteSelectionJourney,
    substituteSelectorAction,
    clearSubstituteSelectorErrorMessage,
    onRemoveStaffDropdownItemClick,
    onDeactivateStaffDropdownItemClick,
    onActivateStaffDropdownItemClick,
  };
};
